<ng-container *ngIf="profile$ | async as profile">
	<ion-grid class="grid-width mr-16 shadow-md rounded-lg">
		<ion-grid class="small-grid mt-16">
			<ion-row class="justify-end">
				<ion-col>
					<img default="/assets/default-img/profile.jpg" alt="title" [src]="profile.data.multimedia"
						class="profile rounded-full" />
				</ion-col>
			</ion-row>
			<ion-row class="justify-end Body_M">
				<ion-col>
					<p class="mt-8">
						{{ profile.data.firstName }} {{ profile.data.lastName }}
					</p>
				</ion-col>
			</ion-row>
		</ion-grid>
		<!-- <ion-grid class="small-grid">
			<ion-row class="justify-end Body_M">
				<ion-col size="12">
					<p class="mb-16 mt-32">📌 Saved items</p>
				</ion-col>
				<ion-col size="12">
					<p class="mb-32 mt-16">🔮 My preferences</p>
				</ion-col>
			</ion-row>
		</ion-grid> -->
		<ion-grid class="Body_M">
			<!-- <ion-row class="justify-end">
				<ion-col size="12">
					<p class="mt-32 mb-16">❓ FAQs</p>
				</ion-col>
				<ion-col size="12">
					<p class="my-16">👋 Get in touch</p>
				</ion-col>
			</ion-row> -->
			<ion-row class="justify-end">
				<ion-col>
					<button class="mt-16 font-size: 1rem font-sans bg-transparent" (click)="logout()">
						👤 Sign out
					</button>
					<p class="Body_XS mb-16">Signed in as {{ profile.data.email }}</p>
				</ion-col>
			</ion-row>
		</ion-grid>
	</ion-grid>
</ng-container>